import Vue from 'vue'
import App from './AppScoresNBA.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

